(function () {
  'use strict';

  function getKlaviyoCompanyId() {
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;
      var pathMatch = src.match(/\/js\/([A-Za-z0-9]{6})\//);
      if (pathMatch) return pathMatch[1];
      var queryMatch = src.match(/company_id=([A-Za-z0-9]{6})/);
      if (queryMatch) return queryMatch[1];
    }
    if (window.klaviyo && window.klaviyo.companyId) return window.klaviyo.companyId;
    console.error('Swarm Zwift: Could not detect Klaviyo company ID');
    return null;
  }

  function regKey(rideName, date) {
    return ('swarm_zwift_reg_' + rideName + '_' + date).toLowerCase().replace(/[^a-z0-9]/g, '_');
  }

  function markAsRegistered(card) {
    card.classList.add('swarm-registered');
    var btn = card.querySelector('.swarm-zwift-register-btn');
    var badge = card.querySelector('.swarm-zwift-registered-badge');
    if (btn) btn.style.display = 'none';
    if (badge) badge.style.display = '';
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trapFocus(e) {
    var modal = document.querySelector('#swarm-zwift-modal-overlay .swarm-modal');
    if (!modal) return;
    var focusable = modal.querySelectorAll(FOCUSABLE);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }

  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var TZ_OFFSETS = { 'AEST': '+10:00', 'AEDT': '+11:00' };

  function isAustralianTimezone(tz) {
    return tz && tz.startsWith('Australia/');
  }

  function parseRideIso(dateStr, timeStr) {
    if (!dateStr || !timeStr) return null;
    var m = timeStr.match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)\s*(AEST|AEDT)?/i);
    if (!m) return null;
    var hours = parseInt(m[1], 10);
    var mins = m[2] ? parseInt(m[2], 10) : 0;
    var period = m[3].toLowerCase();
    var tzKey = m[4] ? m[4].toUpperCase() : 'AEST';
    if (period === 'am' && hours === 12) hours = 0;
    if (period === 'pm' && hours !== 12) hours += 12;
    var offset = TZ_OFFSETS[tzKey] || '+10:00';
    var hh = (hours < 10 ? '0' : '') + hours;
    var mm = (mins < 10 ? '0' : '') + mins;
    return dateStr + 'T' + hh + ':' + mm + ':00' + offset;
  }

  function formatTime12(date) {
    var h = date.getHours();
    var m = date.getMinutes();
    var suffix = h >= 12 ? 'pm' : 'am';
    var h12 = h % 12 || 12;
    var mStr = m > 0 ? ':' + (m < 10 ? '0' : '') + m : '';
    return h12 + mStr + suffix;
  }

  function getShortTzLabel(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en', { timeZone: tz, timeZoneName: 'short' })
        .formatToParts(new Date());
      var tzPart = parts.find(function (p) { return p.type === 'timeZoneName'; });
      return tzPart ? tzPart.value : '';
    } catch (e) {
      return '';
    }
  }

  function ordinal(n) {
    var s = ['th','st','nd','rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function buildLocalString(localDate, tzLabel) {
    return DAYS[localDate.getDay()] + ' ' + ordinal(localDate.getDate()) + ' ' + MONTHS[localDate.getMonth()] + ' at ' + formatTime12(localDate) + (tzLabel ? ' ' + tzLabel : '');
  }

  function convertRideTimes() {
    var tz;
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) { return; }
    if (isAustralianTimezone(tz)) return;

    var tzLabel = getShortTzLabel(tz);
    var blocks = document.querySelectorAll('.swarm-zwift-block');

    blocks.forEach(function (block) {
      var iso = parseRideIso(block.dataset.date, block.dataset.time);
      if (!iso) return;

      var localDate = new Date(iso);
      if (isNaN(localDate.getTime())) return;

      var el = block.querySelector('.swarm-zwift-local-time');
      if (el) {
        el.textContent = 'Your time: ' + buildLocalString(localDate, tzLabel);
        el.style.display = '';
      }
    });
  }

  function init() {
    var overlay = document.getElementById('swarm-zwift-modal-overlay');
    if (!overlay) return;
    if (overlay.dataset.swarmZwiftInit) return;
    overlay.dataset.swarmZwiftInit = 'true';

    var config = {
      companyId: overlay.dataset.companyId || getKlaviyoCompanyId(),
      listId: overlay.dataset.listId
    };

    var currentCard = null;
    var currentRide = {};

    var formView    = document.getElementById('swarm-zwift-form-view');
    var successView = document.getElementById('swarm-zwift-success');
    var rideNameEl  = document.getElementById('swarm-zwift-modal-ride-name') || document.getElementById('swarm-zwift-modal-city');
    var dateEl      = document.getElementById('swarm-zwift-modal-date');
    var detailsEl   = document.getElementById('swarm-zwift-modal-details');
    var form        = document.getElementById('swarm-zwift-reg-form');
    var errorEl     = document.getElementById('swarm-zwift-form-error');
    var firstNameIn = document.getElementById('swarm-zwift-first-name');
    var lastNameIn  = document.getElementById('swarm-zwift-last-name');
    var emailIn     = document.getElementById('swarm-zwift-email');
    var submitBtn   = document.getElementById('swarm-zwift-submit-btn');
    var btnText     = submitBtn.querySelector('.swarm-btn-text');
    var btnLoading  = submitBtn.querySelector('.swarm-btn-loading');
    var successMsg  = document.getElementById('swarm-zwift-success-msg');
    var doneBtn     = overlay.querySelector('.swarm-success-done');
    var closeBtn    = overlay.querySelector('.swarm-modal__close');

    function openModal(cardEl) {
      currentCard = cardEl;
      var d = cardEl.dataset;
      currentRide = {
        rideName: d.rideName || d.city || '',
        date: d.date || '',
        dateDisplay: d.dateDisplay || '',
        time: d.time || '',
        distance: d.distance || '',
        leaderName: d.leaderName || '',
        leaderEmail: d.leaderEmail || '',
        rideMonth: d.rideMonth || '',
        stravaRoute: d.stravaRoute || ''
      };

      rideNameEl.textContent = currentRide.rideName;
      dateEl.textContent = currentRide.dateDisplay;

      var details = '';
      if (currentRide.time) details += '<p><strong>Time:</strong> ' + escHtml(currentRide.time) + '</p>';
      if (currentRide.distance) details += '<p><strong>Distance:</strong> ' + escHtml(currentRide.distance) + '</p>';

      var iso = parseRideIso(currentRide.date, currentRide.time);
      if (iso) {
        var tz;
        try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) { tz = null; }
        if (tz && !isAustralianTimezone(tz)) {
          var rd = new Date(iso);
          if (!isNaN(rd.getTime())) {
            var tzLabel = getShortTzLabel(tz);
            details += '<p class="swarm-zwift-local-time">' + escHtml('Your time: ' + buildLocalString(rd, tzLabel)) + '</p>';
          }
        }
      }

      detailsEl.innerHTML = details;

      form.reset();
      submitBtn.disabled = true;
      errorEl.style.display = 'none';
      errorEl.textContent = '';
      btnText.style.display = '';
      btnLoading.style.display = 'none';
      formView.style.display = '';
      successView.style.display = 'none';

      overlay.style.display = '';
      requestAnimationFrame(function () { overlay.classList.add('swarm-modal--open'); });
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', trapFocus);
      firstNameIn.focus();
    }

    function escHtml(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    function closeModal() {
      overlay.classList.remove('swarm-modal--open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', trapFocus);
      setTimeout(function () { overlay.style.display = 'none'; }, 300);
    }

    closeBtn.addEventListener('click', closeModal);
    doneBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.style.display !== 'none') closeModal();
    });

    function validateForm() {
      var valid =
        firstNameIn.value.trim().length > 0 &&
        isValidEmail(emailIn.value.trim());
      submitBtn.disabled = !valid;
    }

    firstNameIn.addEventListener('input', validateForm);
    emailIn.addEventListener('input', validateForm);

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var firstName = firstNameIn.value.trim();
      var lastName = lastNameIn.value.trim();
      var email = emailIn.value.trim();

      if (!firstName) { showError('Please enter your first name.'); return; }
      if (!isValidEmail(email)) { showError('Please enter a valid email address.'); return; }
      if (!config.companyId) { showError('Registration is temporarily unavailable. Please try again later.'); return; }

      submitBtn.disabled = true;
      btnText.style.display = 'none';
      btnLoading.style.display = '';
      errorEl.style.display = 'none';

      var headers = { 'Content-Type': 'application/json', 'revision': '2026-07-15' };
      var ride = currentRide;
      var baseUrl = 'https://a.klaviyo.com/client/';

      var viewerTz = '';
      var rideTimeLocal = '';
      var rideIso = parseRideIso(ride.date, ride.time);
      try {
        viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        if (rideIso) {
          var ld = new Date(rideIso);
          if (!isNaN(ld.getTime())) {
            rideTimeLocal = buildLocalString(ld, getShortTzLabel(viewerTz));
          }
        }
      } catch (e) { /* ignore */ }
      var rideDateForKlaviyo = rideIso || ride.date;

      var subscribeBody = JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Swarm Zwift Registration',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  last_name: lastName
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: config.listId
              }
            }
          }
        }
      });

      var eventBody = JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: { type: 'metric', attributes: { name: 'Registered for Zwift Ride' } }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  last_name: lastName,
                  properties: {
                    last_swarm_zwift_ride_name: ride.rideName,
                    next_swarm_zwift_ride_date: rideDateForKlaviyo
                  }
                }
              }
            },
            unique_id: (email + '_zwift_' + ride.rideName + '_' + ride.date).toLowerCase().replace(/[^a-z0-9]/g, '_'),
            properties: {
              ride_name: ride.rideName,
              ride_date: ride.date,
              ride_time: ride.time,
              ride_time_local: rideTimeLocal,
              viewer_timezone: viewerTz,
              distance: ride.distance,
              ride_month: ride.rideMonth,
              ride_leader_name: ride.leaderName,
              ride_leader_email: ride.leaderEmail,
              strava_route: ride.stravaRoute
            }
          }
        }
      });

      var profileBody = JSON.stringify({
        data: {
          type: 'profile',
          attributes: {
            email: email,
            first_name: firstName,
            last_name: lastName,
            properties: {
              last_swarm_zwift_ride_name: ride.rideName,
              next_swarm_zwift_ride_date: rideDateForKlaviyo,
              next_swarm_zwift_ride_time: ride.time,
              next_swarm_zwift_ride_time_local: rideTimeLocal,
              swarm_viewer_timezone: viewerTz,
              next_swarm_zwift_distance: ride.distance,
              next_swarm_zwift_strava_route: ride.stravaRoute
            }
          }
        }
      });

      var callNames = ['subscribe', 'event', 'profile'];

      console.log('[Swarm Zwift] Sending registration — company:', config.companyId, 'list:', config.listId, 'email:', email);

      Promise.all([
        fetch(baseUrl + 'subscriptions/?company_id=' + config.companyId, {
          method: 'POST', headers: headers, body: subscribeBody
        }),
        fetch(baseUrl + 'events/?company_id=' + config.companyId, {
          method: 'POST', headers: headers, body: eventBody
        }),
        fetch(baseUrl + 'profiles/?company_id=' + config.companyId, {
          method: 'POST', headers: headers, body: profileBody
        })
      ])
        .then(function (responses) {
          var allOk = true;
          var failedCalls = [];
          responses.forEach(function (r, i) {
            var ok = r.ok || r.status === 202;
            console.log('[Swarm Zwift]', callNames[i], '→', r.status, ok ? '✓' : '✗');
            if (!ok) {
              allOk = false;
              failedCalls.push(callNames[i]);
              r.text().then(function (body) { console.error('[Swarm Zwift]', callNames[i], 'error body:', body); });
            }
          });
          var subOk = responses[0].ok || responses[0].status === 202;
          if (subOk) {
            if (!allOk) {
              console.warn('[Swarm Zwift] Subscribe OK but these calls failed:', failedCalls.join(', '));
            }
            onSuccess(ride);
          } else {
            showError('Registration failed. Please check your email and try again.');
            submitBtn.disabled = false;
            btnText.style.display = '';
            btnLoading.style.display = 'none';
          }
        })
        .catch(function (err) {
          console.error('[Swarm Zwift] Network error:', err);
          showError('Registration failed. Please check your connection and try again.');
          submitBtn.disabled = false;
          btnText.style.display = '';
          btnLoading.style.display = 'none';
        });
    });

    function onSuccess(ride) {
      localStorage.setItem(regKey(ride.rideName, ride.date), 'true');
      if (currentCard) markAsRegistered(currentCard);

      successMsg.textContent = 'You\'re registered for the ' + ride.rideName + ' Zwift ride on ' + ride.dateDisplay + '. See you there!';
      formView.style.display = 'none';
      successView.style.display = '';
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.style.display = '';
    }

    document.querySelectorAll('.swarm-zwift-register-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.closest('.swarm-zwift-block'));
      });
    });

    document.querySelectorAll('.swarm-zwift-block').forEach(function (card) {
      var key = regKey(card.dataset.rideName || card.dataset.city, card.dataset.date);
      if (localStorage.getItem(key)) markAsRegistered(card);
    });

    convertRideTimes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
